import React from 'react';

import CorpSubIcon from 'images/subscribe-icon-corporate.svg';

import { corporate_landing_path } from '@routes';

import Button from '../ButtonLegacy';
import styles from './styles.module.scss';

const CorporateSubscriptionCard = ({
  trackingProps = {},
}: {
  trackingProps?: { [key: string]: string };
}) => {
  return (
    <div className={styles.corpSubCard}>
      <div className={styles.topBarCorp}></div>
      <img src={CorpSubIcon} alt="corporate subscription icon" role="presentation" />
      <div>
        <h4 className={styles.corpSubCardHeader}>Corporate Subscriptions</h4>
        <div className={styles.corpSubCardSubtitle}>
          Get a corporate subscription for your team.
        </div>
      </div>
      <Button
        href={corporate_landing_path()}
        rounded="full"
        trackClick={Object.keys(trackingProps).length > 0}
        trackingProps={trackingProps}
      >
        Contact sales
      </Button>
    </div>
  );
};

export default CorporateSubscriptionCard;
